import styles from "./Section7.module.scss";
import Logo24Months from "./components/Logo24Months";
import LogoAlumni from "./components/LogoAlumni";
import LogoInterestFree from "./components/LogoInterestFree";
import LogoPayInFull from "./components/LogoPayInFull";

type MediaProps = {
  media: JSX.Element;
  title: string;
  content: string;
};

const Media = function ({ media, title, content }: MediaProps) {
  return (
    <div className={styles.flag}>
      <div className={styles.flag__signifier}>{media}</div>
      <div className={styles.flag__title}>
        <strong>{title}</strong>
      </div>
      <div className={styles.flag__content}>{content}</div>
    </div>
  );
};

const FinancialOptions = [
  {
    media: <LogoInterestFree />,
    title: "Interest-Free Payment Plan",
    content:
      "Pay an initial deposit and split the rest of your tuition into monthly installments over the length of the course with no interest.",
  },
  {
    media: <Logo24Months />,
    title: "24-month Interest-Free Payment Plan",
    content:
      "Once approved, you’ll pay your deposit and split the remaining tuition over 24 monthly installments with zero interest.",
  },
  {
    media: <LogoPayInFull />,
    title: "Pay in Full Discount",
    content: "Pay in full at the time of enrollment and receive $1000 off your total fee.",
  },
  {
    media: <LogoAlumni />,
    title: "Alumni Scholarship",
    content: "Alumni are eligible for a $500 scholarship.",
  },
];

export const Section7 = function ({ scrollTo }) {
  return (
    <section className={`${styles.container} cc--component-container`}>
      <div className={styles.inner_container}>
        <h2 className={styles.headline}>
          Invest in Your Career. <br className={styles.hidden_320} />
          Explore Financial Options.
        </h2>
        <h3 className={styles.subheadline}>
          Cybersecurity boot camp fee: <span className="tuition_cost">$15,495</span>
        </h3>
        <section className="cc--component-container">
          <ul className={styles.financial_options}>
            {FinancialOptions.map(({ media, title, content }, index) => (
              <li key={index}>
                <Media media={media} title={title} content={content} />
              </li>
            ))}
          </ul>
        </section>
        <p className={styles.disclaimer}>
          edX Boot Camps does not receive any commissions or payments for referrals or successful loan applications. The
          lender’s loan approval criteria will apply and you should consider the terms and conditions of any loan
          carefully. We are not credit advisors. We make no representations about whether you will be given a loan or
          whether a loan will be suitable for you. We are not responsible for representations made to you by any credit
          provider.
        </p>
        <div className={styles.wp_container_core_buttons_layout}>
          <a onClick={scrollTo} className={`${styles.button} wp-block-button__link`} href="#form">
            DISCUSS FINANCING OPTIONS
          </a>
        </div>
      </div>
    </section>
  );
};
